/* import __COLOCATED_TEMPLATE__ from './ftw-bin-input.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { padLeft } from '../utils';
import { BinaryCluster } from './ftw-bin';

interface FTWBinInputSignature {
  Args: {
    model: BinaryCluster;
    maxlength?: number;
    isInvalid?: boolean;
    onChanging: (value: string) => void;
    onUpdated: (value: string) => void;
  };
  Element: HTMLInputElement;
}

export default class FTWBinaryInput extends Component<FTWBinInputSignature> {
  get maxlength() {
    return this.args.maxlength || 8;
  }
  get isEditing() {
    return false;
  }
  @action handleBlur(event: Event) {
    Promise.resolve(event).then((event) => {
      if (this.isDestroying || !event.target || !(event.target instanceof HTMLInputElement)) return;
      const isBinary = /^[01]+$/.test(event.target.value);
      this.maybeChanging(event);
      if (isBinary) {
        this.args.onUpdated(padLeft(event.target.value, this.maxlength, '0'));
      } else {
        this.args.onUpdated(this.args.model.value);
      }
    });
  }
  @action maybeChanging(event: Event) {
    if (event.target && event.target instanceof HTMLInputElement) {
      if (event.target.value !== this.args.model.value) {
        this.args.onChanging(event.target.value);
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    FtwBinInput: typeof FTWBinaryInput;
  }
}
